(() => {
  angular.module('app').component('timeline', {
    templateUrl: require('./timeline.html'),
    controller: TimelineController,
    controllerAs: 'vm',
    bindings: {
      items: '='
    },
  });

  TimelineController.$inject = [];

  function TimelineController() {
    // const vm = this;
  }
})();
